module.exports = __webpack_public_path__ + "images/social-icons/facebook_32-d94eec92962538be46845f5efb3423a2.png";